import { useForm } from "react-hook-form";
import { CompanionOnboardingPayloadInput } from "../graphql/generated/graphql";

export type CompanionPreferencesFormData = CompanionOnboardingPayloadInput;

const defaultValues: CompanionPreferencesFormData = {
  interests: [],
  careerInterests: [],
  skillsToImprove: [],
  learningStyles: [],
  motivations: [],
  semesterGoal: "",
  assignmentReminders: true,
  studyTimePreference: null,
  checkInFrequency: null,
  textReminders: false,
};

export function useCompanionPreferencesForm(initial?: Partial<CompanionPreferencesFormData>) {
  return useForm<CompanionPreferencesFormData>({
    defaultValues: {
      ...defaultValues,
      ...initial,
    },
    mode: "onChange",
  });
}
